// Inline SVG glyphs for the week-overview KPI cards. These are bespoke 16×16
// outline marks tuned to the card's icon badge; the qampo-ui-library icon set
// has no equivalents, so they live here rather than being imported.

export const OccupancyIcon = () => (
  <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4">
    <rect x="2.25" y="8.5" width="3" height="5.25" rx="1" />
    <rect x="6.5" y="5" width="3" height="8.75" rx="1" />
    <rect x="10.75" y="2.25" width="3" height="11.5" rx="1" />
  </svg>
);

export const DistributionIcon = () => (
  <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4">
    <circle cx="8" cy="8" r="5.5" />
    <path d="M8 8V2.5M8 8L12.9 10.75" strokeLinecap="round" />
  </svg>
);

export const StaffIcon = () => (
  <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4">
    <circle cx="6" cy="5.5" r="2.25" />
    <path d="M1.75 13.5C1.75 11.15 3.65 9.25 6 9.25C8.35 9.25 10.25 11.15 10.25 13.5" strokeLinecap="round" />
    <path d="M10.5 3.6C11.55 3.85 12.3 4.8 12.3 5.9C12.3 7 11.55 7.95 10.5 8.2" strokeLinecap="round" />
    <path d="M11.5 9.4C13.2 9.85 14.25 11.3 14.25 13" strokeLinecap="round" />
  </svg>
);

export const TreatmentsIcon = () => (
  <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4">
    <path d="M1.75 8H4.5L6 4.5L8 11.5L10 6.5L11.25 8H14.25" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const PatientsIcon = () => (
  <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4">
    <circle cx="8" cy="5" r="2.5" />
    <path d="M3 13.5C3 11.0147 5.23858 9 8 9C10.7614 9 13 11.0147 13 13.5" strokeLinecap="round" />
  </svg>
);
